import VS from 'constants/ValidationShema';
import {SELECT_VALUE} from 'constants/VATItems';
import InputLimits from 'constants/InputLimits';
import {CONDITION_TYPE_OTHER, CONDITIONS_LABEL, CONDITIONS_LABEL_PZP_2021} from 'components/popup/newCondition/constants/condition.values';
import {getDemandPZPType} from "libs/getDemandStatus";
import PZPType from "constants/PZPType";
import Tr from 'translations/Translations';
import {CRYTERIUM_TYPE, CRYTERIUM_TYPE_LABEL} from 'components/popup/newCriteria/constants/criterium.type';
import {VARIANT_CODE as CRITERIA_TYPE} from "components/popup/newCriteria/constants/criteria.variants";
import getObjectValue from "libs/getObjectValue";
import {PriceDirections} from "constants/DirectionsItems";
import {SOURCE_TYPES} from "../../../../../../../../constants/OfferSourceTypes";
import {PriceTypeGrossFieldVisible, PriceTypeNetFieldVisible, PriceTypeVatFieldVisible} from "../../../../../../../../constants/PriceTypes";

const inputLimits = InputLimits.procedure.dealings;

const repeadedElement = (elements, getNameFunc) => {
    return elements.find(x => undefined !== elements
        .find(y => {
            if (x.identity === y.identity) return false;
            const xName = getNameFunc(x);
            const yName = getNameFunc(y);
            return xName === yName;
        }))
}

const findRepeatedConditionName = (elements) => {
    const demandPzpType = getDemandPZPType();
    const conditionLabels = PZPType.PZP_2021 === demandPzpType ? CONDITIONS_LABEL_PZP_2021 : CONDITIONS_LABEL;
    const getName = (e) => {
        if (e.type === CONDITION_TYPE_OTHER) return e.otherName;
        return conditionLabels[e.type]
    }
    const e = repeadedElement(elements, getName)
    if (e === undefined) return undefined;
    return getName(e);
}

const findRepeatedCriterionName = (elements) => {
    const getName = (e) => {
        if (e.type === CRYTERIUM_TYPE.PRICE) {
            if (Boolean(e.otherName)) return e.otherName;
        }
        if (e.type === CRYTERIUM_TYPE.OTHER) return e.otherName;
        return CRYTERIUM_TYPE_LABEL[e.type]
    }
    const e = repeadedElement(elements, getName)
    if (e === undefined) return undefined;
    return getName(e);
}

const schema = (dealingsList = {}) => VS.object({

    form: VS.arrayOf(
        VS.lazy(formItem => {
            if (formItem === null) return VS.any();

            const criterions = getObjectValue('stages.0.criterions', formItem);
            const section = criterions.find(x => x.type === CRYTERIUM_TYPE.PRICE);
            const weightVisible = section && section.direction === PriceDirections.DESCENDING_BY_PRICE_ITEMS;

            let criteriaSum = 0;
            if (weightVisible) {
                const items = getObjectValue('items', formItem);
                criteriaSum = items.map(item => parseFloat(item.weight)).reduce((prev, next) => prev + next);
                criteriaSum = parseFloat(criteriaSum.toFixed(2))
            }

            if (formItem._touched || formItem._load) {
                return VS.object({
                    name: VS.stringMax(inputLimits.NAME).nullable(),
                    description: VS.string(),
                    plannedContractorNumberForAgreement: 'Framework' === dealingsList.demandVariant && VS.integerMax(99999),
                    planItemIdentity: !!dealingsList.planRequired && VS.string(),
                    termDescription: VS.any().when(
                        'termOption',
                        {
                            is: 'text',
                            then: VS.stringMaxNoRq(InputLimits.procedure.basicInformation.TERM_DESCRIPTION),
                            otherwise: VS.any()
                        }),
                    termDate: VS.any().when(
                        'termOption',
                        {
                            is: 'date',
                            then: VS.dateMinNoRq(new Date(), Tr("v_data_can_not_be_past")),
                            otherwise: VS.any()
                        }),
                    _weightSum: weightVisible ? VS.mixed().test('weightMin100', Tr('v_number_min_criteria', {min: 100}), () => {
                        return !(criteriaSum < 100)
                    }).test('weightMax100', Tr('v_number_max_criteria', {value: 100}), () => {
                        return !(criteriaSum > 100)
                    }) : VS.any(),
                    amount: VS.lazy(x => {
                        const s = {
                            value: VS.amount(0, false),
                            grossValue: VS.amount(0, false),
                            vatRate: VS.amount(),
                        }
                        if (x.vatRate === SELECT_VALUE.CANCEL ||
                            x.vatRate === SELECT_VALUE.DIFFRENT_VAT) {
                            s.vatRate = VS.any();
                        }
                        if (x.vatRate === SELECT_VALUE.OTHER) {
                            return VS.object({
                                ...s,
                                vatRate: VS.any(),
                                vatRateOther: VS.amountMax100()
                            })
                        }
                        return VS.object(s);
                    }),
                    realizationBeforeOfferAmount: VS.lazy((x) => {
                        return VS.object({
                            grossValue: VS.amountOptional(0, true)
                        })
                    }),
                    items: VS.arrayOf(VS.lazy(item => {
                        const shape = {
                            quantity: VS.object({
                                value: VS.numberMax(1000000000000000),
                                uom: VS.string().nullable()
                            })
                        }

                        shape['name'] = VS.stringMax(inputLimits.NAME).nullable();
                        shape['description'] = VS.stringMaxNoRq(100000).nullable();

                        if (weightVisible) {
                            shape['weight'] = VS.amountMax100NoZero();
                        }

                        shape['offerSourceType'] = VS.any().test('itemFilled', Tr('item_not_filled'), (e) => {
                            return ((!item.offerVatPredefined && SOURCE_TYPES.INITIATOR !== item.offerSourceType) || !PriceTypeVatFieldVisible(dealingsList.priceType) || !!item.offerVatRate)
                                && (SOURCE_TYPES.INITIATOR !== item.offerSourceType || !PriceTypeNetFieldVisible(dealingsList.priceType) || !!item.offerValue)
                                && (SOURCE_TYPES.INITIATOR !== item.offerSourceType || !PriceTypeGrossFieldVisible(dealingsList.priceType) || !!item.offerGrossValue);
                        });

                        return VS.object(shape);
                    })),
                    stages: VS.lazy(stage => {
                        const vsObj = {
                            //conditions: [],
                            criterions: VS.arrayOf(VS.lazy(criterion => {
                                const shape = {
                                    //weight: VS.amountMax100NoZero()
                                }

                                switch (criterion.uiType) {
                                    case CRITERIA_TYPE.LIST:
                                        const maxListPoints = Math.max(...criterion.valuesList.map(o => o.value), 0);
                                        shape.weight = VS.numberMaxMin(maxListPoints, maxListPoints, 'v_number_weight_min_max_points', 'v_number_weight_less_than_points');
                                        break;
                                    case CRITERIA_TYPE.INTERVAL:
                                        const maxRangePoints = Math.max(...criterion.intervalList.map(o => o.value), 0);
                                        shape.weight = VS.numberMaxMin(maxRangePoints, maxRangePoints, 'v_number_weight_min_max_points', 'v_number_weight_less_than_points');
                                        break;
                                    default:
                                        shape.weight = VS.numberMax(100)
                                }

                                return VS.object(shape);
                            }))

                        }
                        const stage0 = stage[0];

                        let criteriaSum = stage0.criterions.map(item => parseFloat(item.weight)).reduce((prev, next) => prev + next, 0);
                        criteriaSum = parseFloat(criteriaSum.toFixed(2));

                        vsObj['_criteriaSum'] = VS.mixed().test('weightMin100', Tr('v_number_min_criteria', {min: 100}), () => {
                            return !(criteriaSum < 100)
                        }).test('weightMax100', Tr('v_number_max_criteria', {value: 100}), () => {
                            return !(criteriaSum > 100)
                        });


                        const conditionsElements = stage0.conditions;
                        const conditionRepeaded = findRepeatedConditionName(conditionsElements);
                        if (conditionRepeaded) vsObj._conditionsError = VS.immediatelyError(Tr('condition_repeats', {name: conditionRepeaded}))

                        const criterionsElements = stage0.criterions;
                        const criterionRepeaded = findRepeatedCriterionName(criterionsElements);
                        if (criterionRepeaded) vsObj._criterionsError = VS.immediatelyError(Tr('criterion_repeats', {name: criterionRepeaded}))

                        return VS.arrayOfShape(vsObj)
                    }),
                    categoryItemCpv: VS.arrayRequired(),

                })
            }
            return VS.any();
        }))
});

export default schema;


// conditions: VS.lazy(elements => {
// 	let obj = {};
// 	const name = findRepeatedConditionName(elements);
// 	if (name) obj._error = Tr('condition_repeats', { name });
// 	return VS.arrayOfShape(obj)
// }),